import React, { FC } from "react";
import styled from "styled-components";
import { SubtotalProps } from "../common/types";
import { convertFromCentsToDollars } from "../../../helpers/currency";

const StyledSubtotal = styled.div<{ small: boolean }>`
  font-weight: 500;
  margin-left: 15px;

  ${({ theme }) =>
    theme.typography.heading.xs.lineHeight &&
    `
    line-height: ${theme.typography.heading.xs.lineHeight};
  `}

  ${({ small }) =>
    small &&
    `
    font-weight: 400;
    font-size: 13px;
    align-self: center;
  `}
`;

export const Subtotal: FC<SubtotalProps> = ({ small = false, subtotal }) => (
  <StyledSubtotal small={small}>
    {convertFromCentsToDollars(subtotal)}
  </StyledSubtotal>
);
